import { ArrowRight } from "lucide-react"

import { useLocale, useLocalHref } from "@/core/i18n/locale-context"
import { gateCta } from "@/core/launch"
import { Button } from "@/ui/button"

interface CtaBandProps {
  title: string
  description?: string
  ctaLabel: string
  ctaHref: string
}

export const CtaBand = ({ title, description, ctaLabel: label, ctaHref: href }: CtaBandProps) => {
  const localHref = useLocalHref()
  const { href: ctaHref, label: ctaLabel } = gateCta({ href, label }, useLocale())
  return (
    <section className="bg-primary text-primary-foreground dark:border-primary/45 dark:bg-accent dark:text-foreground mx-band mt-2 mb-8 flex flex-col items-start justify-between gap-6 rounded-xl px-[18px] py-[22px] md:mb-10 md:flex-row md:items-center md:p-8 dark:border">
      <div>
        <h2 className="text-2xl font-semibold">{title}</h2>
        {description && (
          <p className="dark:text-accent-foreground mt-1.5 opacity-90 dark:opacity-100">
            {description}
          </p>
        )}
      </div>
      <Button
        asChild
        size="lg"
        className="bg-background text-foreground hover:bg-background/90 dark:bg-primary dark:text-primary-foreground h-11"
      >
        <a href={localHref(ctaHref)}>
          <ArrowRight aria-hidden="true" />
          {ctaLabel}
        </a>
      </Button>
    </section>
  )
}
